export default __webpack_public_path__ + "static/media/80-20.df001c8d.png";